import axios from "axios";
import { API } from "../config/BackendUrl";
const url = `${API}/users`;

export const CreateUser = async (formData) => {
  const config = {
    method: "POST",
    url: `${url}/create`,
    data: formData,
    headers: {
      "Content-Type": "application/json",
      // Authorization: `Bearer ${typeof window !== "undefined" &&
      //     JSON.parse(JSON.stringify(localStorage.getItem("token")))
      //     }`,
    },
  };

  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    return error.response.data;
  }
};
export const SingleUserDetails = async (id) => {
  const config = {
    method: "get",

    url: `${url}/${id}`,
    // data: formData,
    headers: {
      "Content-Type": "application/json",
      // Authorization: `Bearer ${typeof window !== "undefined" &&
      //     JSON.parse(JSON.stringify(localStorage.getItem("token")))
      //     }`,
    },
  };

  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    return error.response.data;
  }
};
export const getUserByAddress = async (address) => {
  const config = {
    method: "get",
    url: `${url}/wallet/${address}`,
    headers: {
      "Content-Type": "application/json",
      // Authorization: `Bearer ${typeof window !== "undefined" &&
      //     JSON.parse(JSON.stringify(localStorage.getItem("token")))
      //     }`,
    },
  };

  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    return error.response.data;
  }
};
export const UserUpdate = async (formData, id) => {
  const config = {
    method: "patch",
    url: `${url}/${id}`,
    headers: {
      "Content-Type": "application/json",
      // Authorization: `Bearer ${typeof window !== "undefined" &&
      //     JSON.parse(JSON.stringify(localStorage.getItem("token")))
      //     }`,
    },
    data: JSON.stringify(formData),
  };
  try {
    const res = await axios(config);
    return res;
  } catch (error) {
    return error.response.data;
  }
};
export const UploadUserMedia = async (formData, imgType, id) => {
  const config = {
    method: "patch",
    url: `${url}/${imgType}/${id}`,
    data: formData,
    headers: {
      "Content-Type": "file/json",
      // Authorization: `Bearer ${typeof window !== "undefined" &&
      //     JSON.parse(JSON.stringify(localStorage.getItem("token")))
      //     }`,
    },
  };
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    return error.response;
  }
};

export const UserKyc = async (formData) => {
  const config = {
    method: "POST",
    url: `${url}/details`,
    data: formData,
    headers: {
      "Content-Type": "application/json",
      // Authorization: `Bearer ${typeof window !== "undefined" &&
      //     JSON.parse(JSON.stringify(localStorage.getItem("token")))
      //     }`,
    },
  };

  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    return error.response.data;
  }
};
export const VerifyOTP = async (formData) => {
  const config = {
    method: "POST",
    url: `${url}/verify-otp`,
    data: formData,
    headers: {
      "Content-Type": "application/json",
      // Authorization: `Bearer ${typeof window !== "undefined" &&
      //     JSON.parse(JSON.stringify(localStorage.getItem("token")))
      //     }`,
    },
  };

  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    return error.response.data;
  }
};

export const ResendOTP = async (formData) => {
  const config = {
    method: "POST",
    url: `${url}/resend-otp`,
    data: formData,
    headers: {
      "Content-Type": "application/json",
      // Authorization: `Bearer ${typeof window !== "undefined" &&
      //     JSON.parse(JSON.stringify(localStorage.getItem("token")))
      //     }`,
    },
  };

  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    return error.response.data;
  }
};

export const UserDetailsWithAddress = async (address) => {
  const config = {
    method: "get",

    url: `${url}/${address}`,
    // data: formData,
    headers: {
      "Content-Type": "application/json",
      // Authorization: `Bearer ${typeof window !== "undefined" &&
      //     JSON.parse(JSON.stringify(localStorage.getItem("token")))
      //     }`,
    },
  };

  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    return error.response.data;
  }
};


export const UploadUserdocs = async (id, formData) => {
  const config = {
    method: "post",

    url: `${url}/upload/${id}`,
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data", // Set content type for FormData
    },
  };

  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    return error.response.data;
  }
};